import { IProduct } from '@/context/ProductDataStore'

/**
 * The catalogue can provide a customer-facing name at either the option or
 * product level. Prefer the option label because it identifies the selected
 * add-on or colourway within its catalogue.
 */
export const getProductDisplayName = (
  product: Pick<IProduct, 'optionTitle' | 'productTitle' | 'productName'>,
  fallback = 'Item'
): string => {
  const names = [product.optionTitle, product.productTitle, product.productName]
  return names.find((name): name is string => typeof name === 'string' && name.trim().length > 0)?.trim() || fallback
}
